import { Pipe, PipeTransform, Injectable } from "@angular/core";

@Pipe({
  name: 'filterSections',
  standalone: true,
})

export class FilterSectionsPipe implements PipeTransform {
  transform(sections: any[], term: string): any[] {
    if (!sections || !term) {
      return sections;
    }

    const filteredSections = [];

    sections.forEach(section => {
      const filteredStudents = section.students.filter(student =>
        student.forename?.toLowerCase().includes(term.toLowerCase()) ||
        student.surname?.toLowerCase().includes(term.toLowerCase()) ||
        student.mobile_no?.toLowerCase().includes(term.toLowerCase())
      );

      if (filteredStudents.length > 0) {
        filteredSections.push({ ...section, students: filteredStudents });
      }
    });

    return filteredSections;
  }
}
